import elementsForSelectors from './ElementsForSelectors';
import { END_EDITING_TRIGGER_CLASSNAME } from '@instructure/quiz-common';
export function checkClickedNode(e, appContainer) {
  // Need to iterate over the appNodes since Gauge and lti have a different index for the sdk node
  var appNodes = elementsForSelectors(appContainer);
  var outsideApp = appNodes.every(function (node) {
    return node && !node.contains(e.target);
  });

  // checking if the click was on an element that should end editing
  var endEditingNodes = elementsForSelectors(".".concat(END_EDITING_TRIGGER_CLASSNAME));
  var isEndEditingTrigger = endEditingNodes.some(function (node) {
    return node && node.contains(e.target);
  });
  return {
    isEndEditingTrigger: isEndEditingTrigger,
    outsideApp: outsideApp
  };
}